import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";
import useUpdate from "hooks/useUpdate";
import { handleErrors } from "utils/api";

const InputField = (props) => <Input {...props} />;

const BasicData = ({
  currency_id,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/currencies/${currency_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(
        handleErrors(err?.response?.data?.errors || [])
      );
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Podstawowe informacje", icon: "info" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="row m-b-10">
          <div className="box-6">
            <Field name="name" label="Nazwa" component={InputField} type="text" />
          </div>
          <div className="box-6">
            <Field
              name="identifier"
              label="Identyfikator"
              component={InputField}
              type="text"
            />
          </div>
        </div>
        <div className="row">
          <div className="box-6">
            <Field
              name="default_suggested_price_exchange_rate"
              label="Domyślny kurs w sugerowaniu ceny"
              component={InputField}
              type="number"
              step="0.0001"
            />
          </div>
        </div>
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Pole wymagane!";
  }

  if (!values.identifier) {
    errors.identifier = "Pole wymagane!";
  } else if (!/^[A-Z]{3}$/.test(values.identifier)) {
    errors.identifier = "Identyfikator musi składać się z 3 wielkich liter";
  }

  if (
    values.default_suggested_price_exchange_rate === undefined ||
    values.default_suggested_price_exchange_rate === null ||
    values.default_suggested_price_exchange_rate === ""
  ) {
    errors.default_suggested_price_exchange_rate = "Pole wymagane!";
  } else if (Number(values.default_suggested_price_exchange_rate) <= 0) {
    errors.default_suggested_price_exchange_rate =
      "Kurs musi być większy od 0";
  }

  return errors;
};

export default reduxForm({
  form: "update-currency-basic",
  enableReinitialize: true,
  validate,
})(BasicData);
